import gql from 'graphql-tag'

export default {
  requestPrivateStoreAccess: gql`
    mutation RequestPrivateStoreAccess(
      $storeId: String!
      $email: String!
      $reason: String!
    ) {
      requestPrivateStoreAccess(
        input: { shortId: $storeId, email: $email, reason: $reason }
      ) {
        errors {
          field
          messages
        }
      }
    }
  `
}
